import { currency, percent } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";

interface ProgressChangeProps {
  progressChange: number;
  progressChangePercent: number;
}

const ProgressChange = (props: ProgressChangeProps) => {
  return (
    <div>
      <span className="font-bold">
        {currency.formatByWorkspace(props.progressChange)}
      </span>
      <span className="ml-1 text-gray-600 w-14">
        ({percent.format(props.progressChangePercent)})
      </span>
    </div>
  );
};

export default observer(ProgressChange);
